import type { LDClient } from 'launchdarkly-js-client-sdk';

// Singleton bridge so non-React modules (Apollo links, identify call sites)
// can reach the LD client without prop drilling. Set once per app at boot.
let cachedClient: LDClient | undefined;

export function setLDClient(client: LDClient | undefined): void {
  cachedClient = client;
}

export function getLDClient(): LDClient | undefined {
  return cachedClient;
}
